
const svg = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img"><path fill-rule="evenodd" clip-rule="evenodd" d="M16 18V22H12V18H16ZM12 14V18H8V14H12ZM16 10V14H12V10H16ZM12 6V10H8V6H12ZM16 2V6H12V2H16Z" fill="currentColor"></path></svg>';export default svg;
    